module.exports = __webpack_public_path__ + "static/media/textToSpeech.f7b82b62.svg";